export const printProperties = [
  {title: 'A4', size: 'A4', width: '210mm', height: '297mm'},
  {title: 'A5', size: 'A5', width: '148.5mm', height: '210mm'},
  {title: 'A6', size: 'A6', width: '105mm', height: '148.5mm'},
  {title: '8cm رسید پرینتر', size: '80mm max-content', width: '80mm', height: 'auto'},
]

